import { httpClient } from '@/api/http';

export interface ApiUser {
  id: number;
  firstname: string;
  lastname: string;
  username: string | null;
  email: string;
  dialCode: string;
  mobile: string;
  profileImage: string | null;
  isVerified: boolean;
  country: string;
  userType: 'user' | 'merchant';
  points: number;
  status: 'Active' | 'Blocked' | 'Inactive';
  createdAt: string;
  updatedAt: string;
}

export interface GetUsersParams {
  skip?: number;
  take?: number;
  search?: string;
  role?: string;
}

export interface GetUsersResponse {
  count: number;
  merchantCount: number;
  userCount: number;
  skip: number;
  take: number;
  data: ApiUser[];
}

export async function getUsers(params?: GetUsersParams): Promise<GetUsersResponse> {
  const { data } = await httpClient.get<GetUsersResponse>('/users', { params });
  return data;
}

export type UserStatus = 'Active' | 'Blocked';

export async function updateUserStatus(userId: number, status: UserStatus): Promise<void> {
  await httpClient.post(`/users/${userId}/${status}`);
}

export interface ChangePasswordPayload {
  oldPassword: string;
  newPassword: string;
}

export async function changePassword(payload: ChangePasswordPayload): Promise<void> {
  await httpClient.post('/admin/change-password', payload);
}

export interface UpdateAdminPayload {
  firstname?: string;
  lastname?: string;
  email?: string;
}

export async function updateAdminProfile(payload: UpdateAdminPayload): Promise<void> {
  await httpClient.patch('/admin', payload);
}
